import { render, staticRenderFns } from "./SAP-Nav.vue?vue&type=template&id=55ff527e&"
import script from "./SAP-Nav.vue?vue&type=script&lang=js&"
export * from "./SAP-Nav.vue?vue&type=script&lang=js&"
import style0 from "./SAP-Nav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VToolbarItems})
